import { useLocation, Outlet } from 'react-router-dom';
import SideBar from './SideBar';

const Layout = () => {
    const location = useLocation();

    const showSideBar = location.pathname !== '/login' && location.pathname !== '/register';

    return (
        <div className="flex h-screen">
            {showSideBar && <SideBar />}
            
            <main className="flex-1" id="main-content">
                <Outlet />
            </main>
        </div>
    );
};

export default Layout;
